import { useCentralStore } from "@/dentlab/src/store/Central";
import { Eye, EyeOff, Lock } from "lucide-react";
import { useState, useEffect, useRef } from "react";

export function PrivacySwitch() {
	const { profile, updatePrivacy } = useCentralStore((state) => ({
		profile: state.profile,
		updatePrivacy: state.updatePrivacy,
	}));
	const isPrivacyOn = !!profile?.data_privacy_mode;
	const [showTooltip, setShowTooltip] = useState(false);
	const tooltipTimeoutRef = useRef<NodeJS.Timeout | null>(null);

	// Clear timeout on unmount
	useEffect(() => {
		return () => {
			if (tooltipTimeoutRef.current) {
				clearTimeout(tooltipTimeoutRef.current);
			}
		};
	}, []);

	const handleMouseEnter = () => {
		setShowTooltip(true);
	};

	const handleMouseLeave = () => {
		tooltipTimeoutRef.current = setTimeout(() => {
			setShowTooltip(false);
		}, 300);
	};

	const handleClick = () => {
		updatePrivacy(!isPrivacyOn);
	};

	return (
		<div className="relative flex items-center">
			{/* Custom switch */}
			<button
				type="button"
				onClick={handleClick}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${isPrivacyOn ? "bg-blue-600" : "bg-gray-200"
					}`}
				role="switch"
				aria-checked={isPrivacyOn}
			>

				{/* Thumb/circle */}
				<span
					className={`pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${isPrivacyOn ? "translate-x-5" : "translate-x-0"
						}`}
				>
					{/* Icon for "off" state */}
					<span
						className={`absolute inset-0 flex h-full w-full items-center justify-center transition-opacity ${isPrivacyOn ? "opacity-0" : "opacity-100"
							}`}
					>
						<Lock size={12} className="text-gray-500" />
					</span>

					{/* Icon for "on" state */}
					<span
						className={`absolute inset-0 flex h-full w-full items-center justify-center transition-opacity ${isPrivacyOn ? "opacity-100" : "opacity-0"
							}`}
					>
						<Lock size={12} className="text-blue-600" />
					</span>
				</span>
			</button>
		</div>
	);
}